const breadCrumb = "Lotação de Servidores - Tabelas Básicas";

const routes = [
  {
    path: "/manutencao-beneficios-servidor",
    name: "manutencao-beneficios-servidor",
    meta: {
      allowedPermissions: ["area_curso_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoBeneficiosServidor/ManutencaoBeneficiosServidorHome.vue"
      ),
  },
  {
    path: "/manutencao-beneficios-servidor/novo",
    name: "manutencao-beneficios-servidor-novo",
    meta: {
      allowedPermissions: ["area_curso_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoBeneficiosServidor/ManutencaoBeneficiosServidorCad.vue"
      ),
  },
  {
    path: "/manutencao-beneficios-servidor/editar/:id",
    name: "manutencao-beneficios-servidor-editar",
    meta: {
      allowedPermissions: ["area_curso_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoBeneficiosServidor/ManutencaoBeneficiosServidorEdit.vue"
      ),
  },
];

export default routes;
